import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { formatMoney } from "../EnrollmentDataUtil";
import { Card } from "cxa-components";
import ScreenContext from "./index";

const calculateUtilization = account => {
  let total = 0;
  account.otherBenefits.forEach(benefit => {
    benefit.members.forEach(member => {
      const selectedPlan = member.plans.find(x => x.isSelected);
      if (selectedPlan) {
        total += selectedPlan.price;
      }
    });
  });
  return total;
};

const Wallet = ({ intl, data }) => {
  const [isSticky, setIsSticky] = useState(false);
  const isNarrowScreen = React.useContext(ScreenContext);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const utilizationPoints = data.length > 0 ? calculateUtilization(data[0]) : 0;
  const initBalance = data.length > 0 && data[0].accountBalance;
  const availablePoints =
    initBalance - utilizationPoints >= 0 ? initBalance - utilizationPoints : 0;
  const overPurchasePoints = utilizationPoints > initBalance ? utilizationPoints - initBalance : 0;
  const completedPercentage =
    utilizationPoints <= initBalance
      ? (utilizationPoints / initBalance) * 100
      : (overPurchasePoints / utilizationPoints) * 100;

  const stickyStyle = {
    position: "fixed",
    width: "100vw",
    top: isNarrowScreen ? "4rem" : "0",
    zIndex: 10,
    left: "0",
    backgroundColor: "#FFF",
    boxShadow: "0 4px 4px -2px rgba(0, 0, 0, 0.5)",
    padding: "0.5rem 6vw",
  };

  return (
    <Card style={{ padding: "0" }}>
      <div className="wallet-container">
        <div style={isSticky ? stickyStyle : {}}>
          {!isSticky && (
            <span className="wallet-label">
              <strong>{intl.formatMessage(messages.otherBenefits.yourSelection)}</strong>
            </span>
          )}
          <div>
            <div className="wallet-available">
              <span>{intl.formatMessage(messages.otherBenefits.availableBalance)} </span>
              <strong>{formatMoney(availablePoints)}</strong>
            </div>
            <div
              className="wallet-bar-container"
              style={{
                backgroundColor: `${utilizationPoints <= initBalance ? "#0a375e" : "#4b8bfb"}`,
              }}
            >
              <div
                className="wallet-filler"
                style={{
                  width: `${
                    completedPercentage > 0 && completedPercentage < 2 ? 2 : completedPercentage
                  }%`,
                  backgroundColor: `${utilizationPoints <= initBalance ? "#4b8bfb" : "#e42434"}`,
                  float: `${utilizationPoints > initBalance ? "right" : "left"}`,
                }}
              ></div>
            </div>
            <div className="utilization-container">
              <span>{intl.formatMessage(messages.otherBenefits.usedBalance)} </span>
              <span className="used-balance">
                <strong>
                  {formatMoney(overPurchasePoints > 0 ? initBalance : utilizationPoints)}
                </strong>
              </span>
              {overPurchasePoints > 0 && (
                <span>
                  <span>
                    {" "}
                    + {intl.formatMessage(messages.enrollment.overPurchasedDescription)}:{" "}
                  </span>
                  <span className="over-purchased-balance">
                    <strong>{formatMoney(overPurchasePoints)}</strong>
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

Wallet.propTypes = {
  intl: PropTypes.shape(intlShape).isRequired,
  data: PropTypes.object,
};

export default withRouter(injectIntl(Wallet));



// WEBPACK FOOTER //
// ./components/employee/shop/other-benefits/Wallet.js